// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"802":"c5339c77","921":"30f6f667"}[chunkId] + ".chunk.js";
};